const CartView = () => import('./views/CartView.vue')
const LoginView = () => import('./views/LoginView.vue')
const RegisterView = () => import('./views/RegisterView.vue')
const MyOrderViewSection = () => import('./views/MyOrderViewSection.vue')
const OrderDetailView = () => import('./views/OrderDetailView.vue')
const ProfileView = () => import('./views/ProfileView.vue')
const RestaurantView = () => import('./views/RestaurantView.vue')
const CheckoutView = () => import('./views/CheckoutView.vue')
const PageNotFoundView = () => import('./views/PageNotFoundView.vue')
const LandingView = () => import('./views/LandingView.vue')
const ReceiptView = () => import('./views/ReceiptView.vue')
const RestaurantListView = () => import('./views/RestaurantListView.vue')
const HelpView = () => import('./views/HelpView.vue')
const CompanyInformationView = () => import('./views/CompanyInformationView.vue')

import store from './vuex/store'

export const routes = [
  {
    path: '/',
    alias: '/alias',
    component: LandingView
  },
  {
    path: '/pickup',
    component: RestaurantListView,
    props: { type: 'hot_pickup' }
  },
  {
    path: '/delivery',
    component: RestaurantListView,
    props: { type: 'hot_delivery' }
  },
  {
    path: '/help',
    component: HelpView
  },
  {
    path: '/company',
    alias: ['/about', '/privacy', '/contact'],
    component: CompanyInformationView
  },
  {
    path: '/receipt/:id',
    component: ReceiptView,
    props: true
  },
  {
    path: '/cart',
    component: CartView
  },
  {
    path: '/register',
    component: RegisterView,
    beforeEnter: (to, from, next) => {
      if (store.getters.isLoggedIn) {
        next('/')
      } else {
        next()
      }
    }
  },
  {
    path: '/login',
    component: LoginView
  },
  {
    path: '/orders',
    component: MyOrderViewSection
  },
  {
    path: '/orders/:id',
    component: OrderDetailView,
    props: true
  },
  {
    path: '/profile',
    component: ProfileView
  },
  {
    path: '/restaurant/:slug/:id',
    component: RestaurantView,
    props: true
  },
  {
    path: '/restaurant/:id',
    component: RestaurantView,
    props: true
  },
  {
    path: '/checkout',
    component: CheckoutView,
    beforeEnter: (to, from, next) => {
      if (store.getters.isLoggedIn && store.getters.getCartItems.length > 0) {
        next()
      } else {
        next(from.path)
      }
    }
  },
  {
    path: '*',
    component: PageNotFoundView
  }
]



// WEBPACK FOOTER //
// ./src/routes.js